import { render, staticRenderFns } from "./Enquiry.vue?vue&type=template&id=0c8d50b8&scoped=true&"
import script from "./Enquiry.vue?vue&type=script&lang=js&"
export * from "./Enquiry.vue?vue&type=script&lang=js&"
import style0 from "./Enquiry.vue?vue&type=style&index=0&id=0c8d50b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8d50b8",
  null
  
)

export default component.exports